// Every scene the logged-in user can reach, grouped Location -> Room.
//
// Powers the Scenes page on BOTH shells, so desktop and mobile always list the
// same thing. (Desktop's /scenes used to be a hardcoded "No Scenes Available"
// placeholder while mobile had a working browser — that is what this replaces.)
//
// Cost: ONE getRooms + ONE getWallPanels per location, not per room. The wall
// payload nests buttons and actions, so a location's every scene arrives in that
// single response — see scenesApi.fetchScenesByRoom.
//
// Scenes live under the location's owner (see sceneOwner.js), so each location
// is resolved to its owner first and read as them.

import { getRooms } from '../api/api';
import { fetchScenesByRoom } from '../../ui/desktop/pages/scenes/scenesApi';
import { resolveSceneOwner } from './sceneOwner';

// -> [{ location, ownerId, canEdit, rooms: [{ room, scenes }] }]
//
// `locations` is the user's location list (AppContext.locations).
// Rooms with no scenes are kept: the page still lists them so the owner can see
// where a scene could be added, and a non-owner can see the room simply has none.
export async function fetchScenesTree(userId, locations) {
  const out = [];

  for (const location of locations || []) {
    const locationId = location.LocationID;
    /* eslint-disable no-await-in-loop */
    const ownerId = await resolveSceneOwner(userId, locationId);
    const [roomsRes, byRoom] = await Promise.all([
      getRooms(userId, locationId).catch(() => null),
      fetchScenesByRoom(ownerId).catch(() => ({})),
    ]);
    /* eslint-enable no-await-in-loop */

    const rooms = (Array.isArray(roomsRes?.data) ? roomsRes.data : []).map((room) => ({
      room,
      scenes: byRoom[String(room.RoomID)] || [],
    }));

    out.push({
      location,
      ownerId,
      canEdit: Number(userId) === Number(ownerId),
      rooms,
    });
  }

  return out;
}

export function countScenes(tree) {
  return (tree || []).reduce(
    (n, loc) => n + loc.rooms.reduce((m, r) => m + r.scenes.length, 0),
    0,
  );
}
